/**
商品列表
**/
<template>
	<div style="width: 1200px; margin: auto">
		<!-- 面包屑导航 -->
		<el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">
			<!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
			<el-breadcrumb-item style="cursor: pointer" @click.native="breadcrumbClick(item.id, index, item)"
				v-for="(item, index) in breadcrumbList" :key="item.id">{{ item.name }}</el-breadcrumb-item>
			<el-breadcrumb-item v-if="breadcrumbList.length == 1 ? true : false">所有</el-breadcrumb-item>
		</el-breadcrumb>
		<el-container class="filter_con">
			<el-header class="fisrtNav">
				<el-row>
					<el-col :span="2">
						<span class="labelTitle" v-if="categorylists.length != 0 ? true : false">分类：</span>
					</el-col>
					<el-col :span="22" class="labelcontent">
						<!-- <a
               v-for="(item,index) in categorylists" :key="index"
              style="width: 10%; display: inline-block; margin-bottom: 10px"
              href="https://ceshi.xunyoutest.com?ctl=Product&amp;met=lists&amp;category_id=2267"
              >{{item.name}}
            </a> -->
						<a class="OneLineDisplay"
							style="width: 10%; display: inline-block; margin-bottom: 10px;text-align: center;"
							v-for="(item, index) in categorylists" :key="index" :title="item.name"
							@click="getCommoditylist(item.bxscId, (brandId = ''),1)">{{ item.name }}
						</a>
						<!-- @click="getCategorylist(item.bxscId, (brandId = ''), item.name)" -->
					</el-col>
				</el-row>

				<el-row v-if="brandList.length != 0 ? true : false">
					<el-col :span="2">
						<span class="labelTitle">品类：</span>
					</el-col>
					<el-col :span="22">
						<a class="OneLineDisplay"
							style="width: 10%; display: inline-block; margin-bottom: 10px;text-align: center;"
							v-for="(item, index) in brandList" :key="index" :title="item.name"
							@click="getCategorylist(item.category,'', '',item.bXyBid)">
							<img :src="`${item.logo}`"
								onerror="javascript:this.src='http://xyss.com.cn/%E5%93%81%E7%89%8C.png';"
								style="margin-right: 6px;" width="60" height="60" alt="">
						</a>
					</el-col>
				</el-row>
				<!-- <div class="more_filter">
          <span class="sm_wrap"
            ><em id="sm_txt">查看更多选项</em> <i class="el-icon-arrow-down"></i
          ></span>
        </div> -->
			</el-header>
			<el-container>
				<el-aside width="200px">
					<hotGoods :navTitle="hotGoodsTitle" :hotGoodsList="lefthotGoodsList" :supplieStore='0'></hotGoods>
				</el-aside>
				<el-main class="rightaside">
					<div class="orderby">
						<ul>
							<li :class="selectTag[0]"
								@click="getCommoditylist(formInline.cid, formInline.name||'', 'saleNum', 0)">
								<a data-pjax="#page-container" href="javascript:;" rel="nofollow">热销</a>
							</li>
							<li :class="selectTag[1]" v-if="asc"
								@click="getCommoditylist(formInline.cid, formInline.name||'', 'price', 1,'des')">
								<a data-pjax="#page-container" href="javascript:;" rel="nofollow">价格 <i
										class="el-icon-arrow-up"></i>
								</a>
							</li>
							<li :class="selectTag[1]" v-if="!asc"
								@click="getCommoditylist(formInline.cid, formInline.name||'', 'price', 1,'asc')">
								<a data-pjax="#page-container" href="javascript:;" rel="nofollow">价格 <i
										class="el-icon-arrow-down"></i>
								</a>
							</li>
							<!-- <li :class="selectTag[2]" @click="getCommoditylist()">
                <a
                  data-pjax="#page-container"
                  href="javascript:;"
                  rel="nofollow"
                  >人气</a
                >
              </li> -->
							<li :class="selectTag[3]"
								@click="getCommoditylist(formInline.cid, formInline.name||'', 'createTime', 3)">
								<a data-pjax="#page-container" href="javascript:;" rel="nofollow">上新</a>
							</li>
							<!-- <li>
                <el-checkbox
                  v-model="checked1"
                  @change="showLowGoods"
                  label="仅显示特惠商品"
                ></el-checkbox>
              </li> -->
							<!-- <li>
                <el-checkbox
                  v-model="checked2"
                  @change="showHaveGoodList"
                  label="仅显示有货商品"
                ></el-checkbox>
              </li> -->
						</ul>
					</div>
					<el-row class="right_product" :gutter="20" v-loading="loading">
						<el-col class="bg_goods_body" v-for="(item, index) in rightGoodsList" :key="index" :span="6">
							<!-- 活动角标区域 -->
							<img v-if="item.bxyMarketing!=null&&item.bxyMarketing.activityTypeId!=7&&item.bxyMarketing.activityTypeId!=8"
								class="bg_icon"
								:src="require('@/assets/images/activity_icon/'+item.bxyMarketing.activityTypeId+'.png')"
								onerror="javascript:this.src='http://xyss.com.cn/jifenduihuan.png';">
							<div class="product_item selectItemCss_ls">
								<div class="p-img AA">
									<router-link :to="`/goodsdetail?id=${item.id}`" class="item_link">
										<el-image class="img-responsive" :src="`${item.photos}`" style="display: block">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</router-link>
								</div>
								<div class="pro_name">
									<router-link :to="`/goodsdetail?id=${item.id}`">{{
                    item.name
                  }}</router-link>
								</div>
								<div class="pro_price_add">
									<div class="now_price">
										<i>¥</i>
										<span class="banT" v-if="userInfo.loginName == null ? true : false">?</span>
										<span v-else>{{item.realprice != -1?item.realprice:'面议'}}</span>
									</div>
									<div class="cart add-to-cart">
										<a title="加入购物车" href="javascript:;" data-item_id="1207" @click="
                      item.realprice != -1&&item.type!=2 ?addCart(
                          item.id,
                          item.name,
                          item.specificationlist,
                          item.status,
                          item.approvalStatus
                        ) :$router.push(`/goodsdetail?id=${item.id}`)
                      "> {{item.realprice != -1&&item.type!=2?'加入购物车':'查看详情'}} </a>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<!-- <div class="nodate" v-if="rightGoodsList.length==0?true:false"> -->
						<div class="nodate" v-if="rightGoodsList.length > 0 ? false : true">
							<img :src="require('@/assets/img/noresult.png')"
								onerror="javascript:this.src='http://xyss.com.cn/noresult.png';">
							<div class="first">对不起，对应商品分类或筛选组合下没有商品!</div>
						</div>
					</el-row>
					<el-row>
						<el-col :span="24" class="pagination">
							<!-- 分页组件 -->
							<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
						</el-col>
					</el-row>
				</el-main>
			</el-container>
		</el-container>

		<!-- 加入购物车弹框 -->
		<el-dialog class="addCartBox" :visible.sync="centerDialogVisible" width="30%" center>
			<div style="text-align: center" v-show="successInfo">
				<div class="addGoodsInfo">已成功加入购物车！</div>
				<div>{{ addGoodsName }}</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">继续购物</el-button>
					<el-button type="primary" @click="$router.push('/shoppingcart')">去购物车结算</el-button>
				</span>
			</div>
			<div style="text-align: center" v-show="!successInfo">
				<div>需要登录</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="centerDialogVisible = false">确定</el-button>
				</span>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import hotGoods from "@/components/hotGoods";
	import "@/assets/css/base.css";
	import {
		commoditylist,
		addShoppingCart,
		categorylist,
		shoppingCartlist,
		commoditylistForSecondCategory,
		brandListApi
	} from "@/api/xunyou";
	import Pagination from "@/components/Pagination";
	import bus from "@/utils/bus"; //引入事件中心
	// import '@/assets/xunyou/css/layui.css'
	// import '@/assets/bootstrap.min.csss'
	// arr.slice(2,4)
	export default {
		data() {
			return {
				brandList: [], //分类下品牌
				breadcrumbList: [{
					id: 1,
					name: "首页",
					url: "/"
				}, {
					id: 0,
					name: "所有",
					url: "/goodsList?parentBxscId=0"
				}], //面包屑数组
				userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
				brandId: "",
				loading: false,
				centerDialogVisible: false,
				successInfo: true,
				categorylists: "",
				addGoodsName: "",
				checked1: "",
				checked2: "",
				rightGoodsList: [],
				hotGoodsTitle: "热卖商品",
				isClickCate: false, //是否点击了分类查询
				selectTagIdItem: 0,
				// 查询条件是否选中
				selectTag: ["active", "", "", "", ""],
				priceSort: true,
				pariceSort: 'asc',
				asc: 0, //1.价格升序 0.降序
				lefthotGoodsList: [],
				// 请求数据参数
				formInline: {
					pageSize: 20,
					pageNum: 1,
					cid: "",
					stype: "",
					// stype: 2,
					sortway: true,
					sortname: "saleNum",
				},
				// 分页参数
				pageparm: {
					pageSize: 20,
					currentPage: 1,
					total: 0,
				},
				fullscreenLoading: false
				//   items: [
				//     { types: "text", type: "info", label: "热销" },
				//     { types: "text", type: "info", label: "价格" },
				//     { types: "text", type: "info", label: "人气" },
				//     { types: "sort", type: "info", label: "上新" },
				//     { types: "checked", type: "info", label: "仅显示特惠商品" },
				//     { types: "checked", type: "info", label: "仅显示有货商品" },
				//   ],
			};
		},
		// 注册组件
		components: {
			hotGoods,
			Pagination
		},
		/**
		 * 数据发生改变
		 */

		/**
		 * 创建完毕
		 */
		created() {
			this.brandId = this.$route.query.brandId;
			bus.$on("search", (val) => {
				this.formInline.name = val
				this.getCommoditylist(this.$route.query.parentBxscId || 0, val);
				this.getCommodityHotlist(this.$route.query.parentBxscId || 0, val);
			});
		},
		mounted() {
			console.log('00005');
			if (this.$route.fullPath.indexOf("bxscId") > 0) {
				let breadObj = {
					id: this.$route.query.bxscId,
					name: this.$route.query.bxscName,
					url: `/goodsList?parentBxscId=${this.$route.query.bxscId}`,
				};
				this.breadcrumbList.push(breadObj);
				this.getCategorylist(this.$route.query.bxscId);
				//如果有bxscId分类ID就必须调用分类下品牌
				//this.searchBrand(this.$route.query.bxscId);
			} else {
				this.getCommoditylist(
					this.$route.query.parentBxscId || 0,
					this.$route.query.adWord
				);
				this.getCategorylist(this.$route.query.parentBxscId || "", true);
				this.getCommodityHotlist(
					this.$route.query.parentBxscId || 0,
					this.$route.query.adWord
				);
			}
		},

		/**
		 * 里面的方法只有被调用才会执行
		 */
		methods: {
			// 品牌查询
			/**
			 * bXyBid:分类ID
			 */
			searchBrand(bXyBid) {
				this.brandList = [];
				this.loading = true
				brandListApi({
						bXyBid: bXyBid
					})
					.then(res => {
						if (res.code == 0) {

							res.data.forEach((item) => {
								if (null != item.brandList && item.brandList.length != 0) {
									item.brandList.forEach((b) => {
										this.brandList.push(b);
									})

								}
							})
						}
					})
			},
			// 显示特惠商品
			showLowGoods() {
				if (this.checked1) {
					this.checked2 = false;
					this.rightGoodsList = [];
					this.pageparm.total = 0;
				} else {
					this.getCommoditylist(
						this.$route.query.parentBxscId || -1,
						this.$route.query.adWord
					);
				}
			},
			// 仅显示有货商品
			showHaveGoodList() {
				if (this.checked2) {
					this.checked1 = false;
					this.getCommoditylist(
						this.$route.query.parentBxscId || -1,
						this.$route.query.adWord
					);
				}
			},

			// 分页插件事件
			callFather(parm) {
				this.formInline.pageNum = parm.currentPage;
				this.formInline.pageSize = parm.pageSize;
				// this.isClickCate = false
				this.selectTag[this.selectTagIdItem] = "active";
				this.getCommoditylist(this.formInline.cid, this.formInline.name, this.formInline.sortname, this
					.selectTagIdItem, this.pariceSort);
			},

			// 面包屑点击事件
			breadcrumbClick(id, index, item) {
				console.log('点击导航' + id);
				if (id == 1) {
					// 说明是首页 文字
					this.$router.push("/");
				}
				// let key = this.breadcrumbList.findIndex(v=>v.name==item.name)
				let key = this.breadcrumbList.length - 1;
				if (index == key) {
					return;
				}
				this.breadcrumbList.forEach((value, key) => {
					if (value.id == id) {
						this.breadcrumbList = this.breadcrumbList.slice(0, index + 1);
						this.getCategorylist(id, "");
					}
				});
			},
			// 商品列表分类
			getCategorylist(id, init, name, brandId) {
				console.log('------1');
				this.formInline.cid = id;
				this.formInline.pageNum = 1;
				// 记录到面包屑数组里
				if (name != "" && name != undefined) {
					let breadObj = {
						id: id,
						name: name,
						url: `/goodsList?parentBxscId=${id}`,
					};
					this.breadcrumbList.push(breadObj);
				}
				if (null != brandId && "" != brandId) {
					console.log('点击品牌');
					// this.brandId=brandId;
					this.brandId = "";
					categorylist({
							parentBxscId: id || 0,
						})
						.then((res) => {
							console.log("res", res);
							if (id) {
								this.isClickCate = true;
							}
							this.categorylists = res;
							// if (!init) {
							//   this.getCommoditylist(id);
							//   this.getCommodityHotlist(id);
							// }
						})
						.catch((err) => {
							this.$message.error("查询商品分类失败，请稍后再试！");
						});
				} else {
					//非点击品牌
					//获取最新的品牌
					if (this.breadcrumbList.length <= 2) {
						//查所有
						this.searchBrand('');
					} else {
						//差第三级面包级，也就分类的第一
						this.searchBrand(this.breadcrumbList[2].id);
					}
				}
				if (!init) {
					this.getCommoditylist(id);
					this.getCommodityHotlist(id);
				}

			},
			openFullScreen1() {
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				setTimeout(() => {
					loading.close();
				}, 500);
			},
			// 商品列表查询
			getCommoditylist(id, adWord, sortname, selectTagId, sort) {
				if (!sortname) sortname = 'saleNum'
				if (sortname == 1) sortname = ''
				this.selectTagIdItem = selectTagId;
				this.formInline.sortname = sortname;
				this.pariceSort = sort;
				this.loading = true;
				// this.formInline.sortway = true;
				// if (selectTagId == 1 && this.selectTag[selectTagId] === "active" ) {
				//   this.priceSort = sort=='asc'?true:false;
				//   this.asc = this.priceSort?1:0
				//   this.formInline.sortway = this.asc == 1?true:false;
				// }
				if (sort == 'asc') {
					this.formInline.sortway = true
					this.asc = 1
				} else {
					this.formInline.sortway = false
					this.asc = 0
				}
				if (selectTagId == null) {
					this.selectTag[0] = "active"; //  更改检索条件样式
				} else {
					this.selectTag = [];
					this.selectTag[selectTagId] = "active"; //  更改检索条件样式
				}
				this.formInline.cid = id || "";
				this.formInline.name = adWord || "";
				this.formInline.brandId = this.brandId || "";
				this.formInline.userId = this.userInfo.userId || "";
				if (this.$route.fullPath.indexOf("secondCategory") > 0 || this.isClickCate) {
					console.log(this.formInline);
					commoditylistForSecondCategory(this.formInline)
						.then((res) => {
							//   if (res.code == 0) {
							this.loading = false;
							// if(id==''){
							console.log();
							this.rightGoodsList = res.rows;
							this.pageparm.total = res.total;
							// }
							// this.lefthotGoodsList =
							//   res.rows.length > 4 ? res.rows.slice(0, 4) : res.rows;
							// this.childMsgs.total = res.total
							// 分页赋值
							this.pageparm.currentPage = this.formInline.pageNum;
							this.pageparm.pageSize = this.formInline.pageSize;
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("查询商品列表失败，请稍后再试！");
						});
				} else {
					if (this.userInfo.userId) {
						this.formInline.userId = this.userInfo.userId
					}
					commoditylist(this.formInline)
						.then((res) => {
							//   if (res.code == 0) {
							this.loading = false;
							// if(id==''){
							this.rightGoodsList = res.rows;
							this.pageparm.total = res.total;
							// }
							// this.lefthotGoodsList =
							//   res.rows.length > 4 ? res.rows.slice(0, 4) : res.rows;
							// this.childMsgs.total = res.total
							// 分页赋值
							this.pageparm.currentPage = this.formInline.pageNum;
							this.pageparm.pageSize = this.formInline.pageSize;
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("查询商品列表失败，请稍后再试！");
						});
				}
			},

			// 商品列表 热卖 查询
			getCommodityHotlist(id, adWord, sortname, selectTagId) {

				this.formInline.sortname = sortname || this.formInline.sortname;
				this.loading = true;
				this.formInline.sortway = false;
				if (selectTagId == 1 && this.selectTag[selectTagId] === "active") {
					this.priceSort = !this.priceSort;
					this.formInline.sortway = this.priceSort;
				}
				if (selectTagId == null) {
					this.selectTag[0] = "active"; //  更改检索条件样式
				} else {
					this.selectTag = [];
					this.selectTag[selectTagId] = "active"; //  更改检索条件样式
				}
				this.formInline.cid = id || "";
				this.formInline.name = adWord || "";
				this.formInline.brandId = this.brandId || "";
				if (this.$route.fullPath.indexOf("secondCategory") > 0 || this.isClickCate) {
					commoditylistForSecondCategory(this.formInline)
						.then((res) => {
							//   if (res.code == 0) {
							this.loading = false;
							this.lefthotGoodsList = res.rows.length > 4 ? res.rows.slice(0, 4) : res.rows;
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("查询商品列表失败，请稍后再试！");
						});
				} else {
					if (this.userInfo.userId) {
						this.formInline.userId = this.userInfo.userId
					}
					commoditylist(this.formInline)
						.then((res) => {
							//   if (res.code == 0) {
							this.loading = false;
							this.lefthotGoodsList =
								res.rows.length > 4 ? res.rows.slice(0, 4) : res.rows;
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("查询商品列表失败，请稍后再试！");
						});
				}
			},

			// 获取购物车
			getshoppingCartlist() {
				shoppingCartlist({
						uid: this.userInfo.userId || ""
					})
					.then((res) => {
						if (res.length > 0) {
							this.$store.commit("getCartList", res);
						}
					})
					.catch((err) => {
						this.$message.error("购物车查询失败，请稍后再试！");
					});
			},
			addCart(id, name, specificationlist, status, approvalStatus) {
				if (this.userInfo.userId == undefined) {
					this.$message.error("请登录！");
					setTimeout(() => {
						this.$router.push("/login");
					}, 2000);
					return;
				}
				if (status == 1 && approvalStatus == 1) {
					addShoppingCart({
							cid: id,
							uid: this.userInfo.userId,
							number: 1,
							bxysid: 0,
							// bxysid:specificationlist.length>0?specificationlist[0].bXySid:0
						})
						.then((res) => {
							if (res.code == 0) {
								console.log("res", res);
								this.addGoodsName = name;
								this.centerDialogVisible = true;
								this.getshoppingCartlist();
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("添加购物车失败，请稍后再试！");
						});
				} else {
					this.$message.error("暂时缺货");
					return;
				}
			},
		},
	};
</script>

<style scoped lang='less'>
	/**活动商品角标 */
	.bg_goods_body {
		position: relative;
	}

	img.bg_icon {
		position: absolute;
		width: 150px;
		height: 150px;
		z-index: 12;
		left: 7px;
		top: -3px;
	}

	.breakcrumbHeader {
		margin: 15px 0;

		/deep/.el-breadcrumb__inner:hover {
			color: #e4393c;
		}
	}

	.labelTitle {
		text-align: left;
		padding-left: 15px;
		font-weight: bold;
		color: #666;
		font-size: 14px;
	}

	.labelcontent {}

	.fisrtNav {
		padding: 10px 0px;
		border-top: 1px dashed #ddd;
		border-bottom: 1px dashed #ddd;
		margin-bottom: 20px;
	}

	.leftaside {
		/* background: pink; */
		/* padding: 10px; */
		box-sizing: border-box;
		font-size: 14px;
		border: 1px solid #ddd;
		margin-right: 10px;
	}

	.leftaside h4 {
		padding: 10px;
		border-bottom: 1px solid #ddd;
	}

	.left_product {
		padding: 10px;
	}

	.left_product li {
		margin-bottom: 30px;
	}

	.pro-price {
		margin: 10px 0;
		color: #e4393c;
	}

	.pro_name {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		font-size: 14px;
		margin: 10px 0;
		line-height: 22px;
		height: 40px;
	}

	.img-responsive {
		/* width: 100%; */
		width: 200px;
		height: 200px;
	}

	.rightaside {
		/* background: yellow; */
		padding: 0px;
		box-sizing: border-box;
		overflow: hidden;
	}

	.el-header {
		height: auto !important;
	}

	/* 右边 */
	.orderby {
		width: 100%;
		padding: 8px 0;
		background: #f1f1f1;
	}

	.orderby ul {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.orderby ul li {
		background: #fff;
		color: #333;
		margin-left: 10px;
		border: 1px solid #ddd;
		font-size: 12px;
		padding: 2px 15px;
		line-height: 20px;
	}

	.active {
		background: #ba3232 !important;
		font-weight: bold;
	}

	.active a {
		color: white !important;
	}

	.orderby .el-checkbox__label {
		font-size: 12px !important;
	}

	.orderby .el-checkbox__input {
		vertical-align: bottom !important;
	}

	.right_product {
		padding: 20px;
	}

	.right_product .product_item {
		margin-bottom: 20px;
		border: 1px solid #fff;
		border-color: #e9e9e9;
		-webkit-box-shadow: 0 0 2px 2px #f8f8f8;
		box-shadow: 0 0 2px 2px #f8f8f8;
		padding: 10px;
		box-sizing: border-box;
	}

	.product_item:hover img {
		opacity: 0.7;
	}

	.pro_price_add {
		display: flex;
		justify-content: space-around;
	}

	.cart.add-to-cart,
	div.now_price {
		flex: 1;
		font-weight: bold;
		border: 1px solid #f12b2d;
		padding: 8px 0;
		text-align: center;
	}

	/* .cart.add-to-cart:hover{
	border: 1px solid #f12b2d;
} */
	div.now_price {
		color: white;
		background: #f12b2d;
		border: 1px solid #f12b2d;
	}

	div.banT {
		color: #f12b2d;
	}

	.dialog-footer {
		margin-top: 20px;
		display: block;
	}

	.addGoodsInfo {
		font-size: 24px;
	}

	.addCartBox .el-button--primary {
		color: #fff;
		background-color: #ff6700;
		border-color: #e65d00;
	}

	.more_filter {
		width: 100%;
		text-align: center;
		border-top: 1px dashed #ddd;
		margin-top: -1px;
	}

	.more_filter:hover {
		border-color: #e13c41;
	}

	.more_filter span {
		display: inline-block;
		height: 30px;
		line-height: 26px;
		margin-top: -1px;
		width: 130px;
		text-align: center;
		border-width: 1px;
		border-style: dashed;
		border-color: #fff #ddd #ddd;
		background: #fff;
		font-size: 12px;
		color: #939393;
		cursor: pointer;
	}

	.filter_con .more_filter span i {
		font-size: 12px;
	}

	.filter_con .more_filter:hover span {
		color: #e13c41;
		border-color: #fff #e13c41 #e13c41;
	}

	.nodate {
		text-align: center;
		margin: 10% 0;
		font-size: 16px;
	}

	.nodate .first {
		margin: 40upx 0 12upx;
		font-size: 28upx;
		color: rgb(210, 210, 210);
	}

	.pagination {
		text-align: right;

		/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #ff6700;
			color: #fff;
			width: 20px;
		}

		/deep/.el-pagination.is-background .btn-next,
		/deep/.el-pagination.is-background .btn-prev,
		/deep/.el-pagination.is-background .el-pager li {
			width: 20px;
		}

		/deep/input[disabled],
		input[disabled="disabled"],
		input[readonly],
		input[readonly="readonly"] {
			background-color: transparent;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/goodsList/index.vue